var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 865,
    height: 407,
    viewBox: "0 0 865 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    id: "path-l",
    d: "M862.283 118.626C867.306 143.983 860.097 170.536 842.716 196.855C825.335 223.175 797.792 249.245 762.183 273.616C690.965 322.357 587.526 364.275 468.746 387.803C349.966 411.331 238.358 412.01 153.938 394.098C111.727 385.141 76.3251 371.54 50.2232 353.833C24.1225 336.127 7.33506 314.326 2.3124 288.97C-2.71026 263.613 4.49925 237.059 21.8794 210.74C39.2604 184.42 66.8039 158.35 102.413 133.98C173.631 85.2383 277.07 43.321 395.85 19.793C514.63 -3.73502 626.238 -4.41428 710.658 13.498C752.869 22.4543 788.271 36.0559 814.373 53.763C840.473 71.4692 857.261 93.2695 862.283 118.626Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL);
export default __webpack_public_path__ + "static/media/l.b1d838fb.svg";
export { ForwardRef as ReactComponent };